/**
 * Initial state
 * @type {Object}
 */
const initialState = {

};

/**
 * App Reducer
 * @param {Object} state
 * @param {[Object]} action
 */
const App = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default App;
